module.exports = __webpack_public_path__ + "static/media/Android.8df596ec.svg";